<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex align-center mb-5">
        <v-btn icon class="mr-2" @click="GoBack()" title="Wróć">
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
        <div class="text-h5">
          {{ $t("admin.userBetsTitle") }}: {{ user.login }}
        </div>
      </div>

      <div class="text-caption grey--text text--darken-1 mb-4">
        {{ $t("admin.userBetsHint") }}
      </div>

      <div>
        <h3 v-if="!competitions[0] && !competitionsLoading">
          Brak typów do wyświetlenia
        </h3>
        <v-select
          v-else
          label="Rozgrywki"
          dense
          outlined
          multiple
          v-model="competitionsSelected"
          :items="competitions"
          item-text="competitionsFullName"
          item-value="competitionsId"
          return-object
          chips
          deletable-chips
          small-chips
          :loading="competitionsLoading"
        ></v-select>
      </div>
      <AdminBookmakerBets
        v-for="comps in competitionsSelected"
        :key="comps.competitionsId"
        class="mb-10"
        :competitions="comps"
        :betRecords="GetBetRecords(comps.competitionsId)"
        :userId="userId"
        @bet-saved="$_setBookmakerBetsItems"
      />
    </v-col>
  </v-row>
</template>

<script>
import UserService from "@/services/UserService.js";
import AdminService from "@/services/AdminService.js";
import AdminBookmakerBets from "@/components/bookmaker/AdminBookmakerBets.vue";
import dayjs from "@/plugins/dayjs.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AdminUserBetsView",
  props: {
    userId: {
      type: String,
      require: true,
    },
  },
  components: {
    AdminBookmakerBets,
  },
  data() {
    return {
      user: {},
      competitions: [],
      competitionsSelected: [],
      bookmakerMatches: [],
      competitionsLoading: true,
    };
  },
  async mounted() {
    await this.$_setUserData();
    await this.setCompetitions();
    await this.$_setBookmakerBetsItems();
    this.competitions = this.$_getLeagueCompetitions();
    this.competitionsSelected = this.competitions;
  },
  methods: {
    ...mapGetters("common", ["getCompetitions"]),
    ...mapActions("common", ["setCompetitions"]),
    GoBack() {
      this.$router.push({ name: "AdminUsers" }).catch(() => {});
    },
    GetBetRecords(competitionsId) {
      return this.bookmakerMatches
        .filter((x) => x.competitionsId === competitionsId)
        .map((x) => x.userBets)
        .flat();
    },
    async $_setUserData() {
      try {
        const response = await UserService.GetUser(this.userId);
        const result = response.data;
        if (result.success) {
          this.user = result.data;
        }
      } catch (err) {
        //
      }
    },
    async $_setBookmakerBetsItems() {
      try {
        this.competitionsLoading = true;
        const response = await AdminService.GetUserBets(this.userId);

        const result = response.data;
        if (result.success) {
          this.bookmakerMatches = result.data.map((x) => {
            x.userBets.map((b) => {
              b.match = {
                ...b.match,
                matchDate: this.$_getMatchDate(b.match.matchDateTime),
                matchDateFriendly: this.$_getMatchDateFriendly(
                  b.match.matchDateTime
                ),
                matchTime: this.$_getMatchTime(b.match.matchDateTime),
              };
            });
            return x;
          });
        }
      } catch (err) {
        //
      } finally {
        this.competitionsLoading = false;
      }
    },
    $_getLeagueCompetitions() {
      const ids = this.bookmakerMatches.map((x) =>
        x.competitionsId.toUpperCase()
      );

      const leagueComps = this.getCompetitions().filter((x) =>
        ids.includes(x.competitionsId.toUpperCase())
      );

      return leagueComps;
    },
    $_getMatchDate(dateTime) {
      return dayjs(dateTime).format("YYYY MMMM DD");
    },
    $_getMatchDateFriendly(dateTime) {
      return dayjs(dateTime).format("DD MMMM YYYY, dddd");
    },
    $_getMatchTime(dateTime) {
      return dayjs(dateTime).format("HH:mm");
    },
  },
};
</script>
